export function calcEdgeWeight(diameter, { a, b }) {
  //console.log(`diameter-weight: ${diameter * a + b}`, `diameter: ${diameter}`);
  return diameter * a + b;
}
